@if (showField) {
    <div
        class="agpr-formField agpr-textField"
        [ngStyle]="style"
    >
    @let autoGenerated = block?.displayElement?.canAutomaticallyGenerated && block?.displayElement?.automaticallyGenerated;

    @if (field.multiline) {
        <agpr-textarea-input
            #textareaInput
            [id]="id + '.textFieldInput'"
            class="agpr-textField-input"
            [label]="field.label"
            [ariaLabel]="field.label"
            [tooltip]="field.tooltip"
            [placeholder]="(autoGenerated ? field.disabledPlaceholder : field.placeholder) | localize"
            [ariaDescribedBy]="field.description ? id + '_description' : ''"
            [(ngModel)]="value"
            (ngModelChange)="onChange($event)"
            [required]="field.required"
            [maxlength]="field.maxLength"
            [disabled]="autoGenerated"
            [rows] = "4"
            [resize]="field.resizeDirections"
            [icon]="field.icon"
            autosizeTextArea
        ></agpr-textarea-input>
    } @else {
        <agpr-text-input
            #textInput
            [id]="id + '.textFieldInput'"
            class="agpr-textField-input"
            [label]="field.label"
            [ariaLabel]="field.label"
            [tooltip]="field.tooltip"
            [placeholder]="(autoGenerated ? field.disabledPlaceholder : field.placeholder) | localize"
            [ariaDescribedBy]="id + '_error' + (field.description ? ' ' + id + '_description' : '')"
            [(ngModel)]="value"
            (change)="onChange($event)"
            [maxLength]="field.maxLength"
            [required]="field.required"
            [disabled]="autoGenerated"
            [bottomMargin]="field.bottomMargin"
        ></agpr-text-input>
    }
    @if (errorMessage) {
        <agpr-form-message [id]="id + '_error'">
            {{ errorMessage | localize }}
        </agpr-form-message>
    }
    @if (field.description) {
        <div
            [id]="id + '_description'"
            class="agpr-formField-description"
        >
            {{ field.description | localize }}
        </div>
    }
    </div>
}
